import { RulesEffects } from '@app/_store/features/rules/rules.effects';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { rulesFeature } from './rules.reducer';

export const rulesStore = [
  provideState(rulesFeature),
  provideEffects(RulesEffects),
];
